import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100%","height":"100%","margin":"0","padding":"0"},
  id: "management-app-container"
}, null, -1)

import { onMounted } from "vue";
import GenericFragment from "@/views/development/GenericFragment.vue";

// Make process.env.DEV_TK available at localStorage.tk to Simulate Feegow

export default /*#__PURE__*/_defineComponent({
  __name: 'DevNoaManagementAppView',
  setup(__props) {

const devTk = process.env.DEV_TK || localStorage.getItem("tk");

if (devTk) {
  localStorage.setItem("tk", devTk);
}

const props = {
  license: { id: 17973, name: "Bruno Fidalgo Medical Center" },
  session: {
    user: {
      id: 160044995,
      email: "dennys.oliveira@docplanner.com",
      admin: true,
      name: "Dennys Oliveira",
    },
  },
};

function waitForMountFunction(): Promise<any> {
  return new Promise((resolve, reject) => {
    const check = () => {
      const fn = (window as any)["noa-management-app"]?.mountApp;
      if (typeof fn === "function") {
        resolve(fn);
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  });
}

onMounted(async () => {
  const mountFn = await waitForMountFunction();
  const container = document.getElementById("management-app-container");
  if (container && typeof mountFn === "function") {
    mountFn(container, props);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GenericFragment, {
    title: "NOA Management App",
    description: "Simulated Feegow background with NOA micro-frontend injection.",
    scriptName: "noa-management-app"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})